import {J20200710_WeekTemplate} from './2020-07-10_week-template';

export default {
    'J20200710_WeekTemplate': J20200710_WeekTemplate
}
